import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "react-oidc-context";
import { RootState } from "./store";
import { IndexRoutes } from "./routes/IndexRoutes";
import { agregarToken, setUsuario } from "./features/ui/uiSlice";

const SSOAuthHandler: React.FC = () => {
  const auth = useAuth();
  const dispatch = useDispatch();

  // Referencia para evitar múltiples redirecciones por el Strict Mode
  const hasTriedSignin = useRef(false);

  // 1. Efecto principal: Flujo de inicio de sesión
  useEffect(() => {
    if (auth.error || auth.isLoading || auth.activeNavigator) {
      return;
    }

    if (!auth.isAuthenticated && !hasTriedSignin.current) {
      hasTriedSignin.current = true;
      auth.signinRedirect();
      return;
    }

    if (auth.isAuthenticated) {
      dispatch(setUsuario(auth.user.profile));
      dispatch(agregarToken(auth.user.access_token));
    }
    const onUserLoaded = (user: any) => {
      dispatch(agregarToken(user.access_token));
      dispatch(setUsuario(user.profile));
    };

    auth.events.addUserLoaded(onUserLoaded);

    return () => {
      auth.events.removeUserLoaded(onUserLoaded);
    };
  }, [
    auth.isLoading,
    auth.isAuthenticated,
    auth.user,
    auth.error,
    auth.activeNavigator,
    dispatch
  ]);
  return null;
};

const App: React.FC = () => {
  const { usuario } = useSelector((state: RootState) => state.ui);
  const isSSO = import.meta.env.VITE_SSO === "true";

  return (
    <>
      <SSOAuthHandler />

      {/* Pantalla de carga mientras obtiene el usuario */}
      {isSSO && !usuario?.name ? (
        <div className="flex h-screen w-full flex-col items-center justify-center gap-4 bg-slate-50">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-t-transparent"></div>
          <h2 className="font-semibold text-slate-700">Autenticando con SSO...</h2>
        </div>
      ) : (
        /* Cuando ya hay usuario, muestra las rutas (pero SSOAuthHandler sigue vivo arriba) */
        <IndexRoutes />
      )}
    </>
  );
};

export default App;
